import React from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { removefromcart } from '../Slice';

const Cart = () => {

        const cartItems = useSelector((state) => state.products.items);
        const dispatch = useDispatch()
  return (
    <div className='checkout'>
        <div className='checkout-content'>
            <h2>Cart</h2>
            <h3>Quantity</h3>
            <h4>Cost</h4>
        </div>
        <hr/>
        {
            cartItems.map((e,k)=>{
                return (
                    <div key={k} className='cart-content'>
                        <img src={e.images} alt={e.title}/>
                        <hr/>
                        <h3>Name: {e.title}</h3>
                        <p>Cost: ${e.price}</p>
                        <p>Quantity:{e.quantity}</p>
                        <button onClick={()=>dispatch(removefromcart({ id: e.id }))}>Remove</button>
                    </div>
                )
            })
        }
    </div>
  )
}

export default Cart